import _default from './Progress';
export { _default as default };